import {cookieSecuritySettings} from '@vio/core/src/_web/utils/cookies/cookieSecuritySettings'

const maxAge = 365 * 30 // 30 years
const name = 'languageCode'

const config = {
  name,
  options: {
    maxAge,
    ...cookieSecuritySettings(true)
  }
}

export default config
